import * as React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export interface EntityNarrowSidePanelChromeProps {
  panelOpen: boolean;
  onOpenPanel: () => void;
  onClosePanel: () => void;
  tabLabel: string;
  panelWidthPx: number;
  children: React.ReactNode;
}

export const EntityNarrowSidePanelChrome: React.FC<
  EntityNarrowSidePanelChromeProps
> = ({
  panelOpen,
  onOpenPanel,
  onClosePanel,
  tabLabel,
  panelWidthPx,
  children,
}) => {
  const { t } = useTranslation();
  // Keep the panel pinned below app + entity headers so opening a guide
  // (extra content above the shell) cannot push it to the bottom of the screen.
  const panelTopPx = 136;
  const panelHeight = 'calc(100vh - 180px)';

  if (panelOpen) {
    return (
      <div
        className="entity-narrow-side-panel"
        style={{
          height: panelHeight,
          position: 'fixed',
          top: panelTopPx,
          right: 17,
          width: panelWidthPx,
          maxWidth: `min(${panelWidthPx}px, 90vw)`,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '6px 6px 2px',
          }}
        >
          <button
            type="button"
            onClick={onClosePanel}
            aria-label={t('organisation.narrow-side-panel-close')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              padding: 0,
              margin: 0,
              border: 'none',
              borderRadius: 6,
              background: 'transparent',
              cursor: 'pointer',
              color: 'var(--color-text-muted, #5a6a6a)',
            }}
          >
            <CloseOutlined style={{ fontSize: 16 }} />
          </button>
        </div>
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          {children}
        </div>
      </div>
    );
  }
  return (
    <button
      type="button"
      className="entity-narrow-side-panel-tab"
      onClick={onOpenPanel}
      style={{ top: panelTopPx }}
    >
      <span className="entity-narrow-side-panel-tab__label">{tabLabel}</span>
    </button>
  );
};
